// 房间 on a phone (artin 10-28: 「手机版也许可以直接优先显示会议室，每个房间的人。」): a 「地图 | 房间」 switch in the
// top bar (phones only; the choice is remembered, 地图 by default) and, on 房间, every room of this floor with who is in
// it, drawn by the engine UI kit (deck/rooms-view.js). Rooms with people come first (in the map's order), then 甲板上
// (the open deck and the sea), then the empty rooms. 进去 / 加入会议 walks me in the way the map's room card does
// (pick.js enterZone: travelTo, sailing if need be) and shows the map; 回到会议 opens the meeting view of the 会议室 I'm
// in; a tap on someone walks me to them. Live from what the page already has (positions, mute, camera, talking,
// status): no new messages and nothing more from the office. A guest sees the same rooms: the office lets guests into
// every room of the floors their invite covers (office.ts GUEST_DENIED names no rooms), and they only ever see the
// floor they are on. Other floors are separate offices this page isn't connected to, so they aren't listed.
import { t, tr } from '/i18n.js';
const KEY = 'deck.view'; // 'rooms': 房间 was picked last time; anything else: 地图
const HUTS = new Set(['game', 'spy', 'bonk']); // the game huts (public/games.js)
const TICK_MS = 400;
const PHONE = '(max-width: 640px), (pointer: coarse) and (max-height: 500px)';
/** A room's kind, as its card's subtitle says it: catalog keys. */
const KIND = { game: 'rooms.kind.game', meeting: 'rooms.kind.meeting' };

const CSS = `
#viewSeg{display:none;box-sizing:border-box;height:30px;border:2px solid #1b1410;border-radius:10px;overflow:hidden;background:#fff8e7;flex:none}
#viewSeg button{font:12px/1 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410;border:0;background:transparent;padding:0 12px;cursor:pointer;white-space:nowrap}
#viewSeg button+button{border-left:2px solid #1b1410}
#viewSeg button.on{background:#FDD03B;font-weight:700;cursor:default}
@media ${PHONE}{#viewSeg.ready{display:flex}
 /* the meeting's small window (public/meeting.js) goes under the top pills, which take two rows on a phone, so it
    never covers the settings button or this switch (--pillsb: the pills' bottom edge, measured below) */
 #meetMini{top:calc(var(--pillsb, 52px) + 8px)}}
/* the rooms view covers the map: what floats over the map (its cards, the recenter button, the chat log, Raft avatars, shared screens) waits */
body.rooms-on #recenter,body.rooms-on .zoom,body.rooms-on #chatlog,body.rooms-on #faces,body.rooms-on #screens,body.rooms-on #pickCard,body.rooms-on #greetbox,body.rooms-on #wbPill,body.rooms-on #meetMini{display:none!important}
`;

/**
 * @param {object} o
 * @param {object} o.MAP the map (its zones change with the map editor: read each time)
 * @param {() => object|null} o.me  @param {() => Map} o.peers  @param {(x, y) => object|null} o.zoneAt
 * @param {(p) => boolean} o.speaking  @param {(p) => object} o.lookOf  @param {(p) => object|null} o.statusOf  @param {object} o.STATES
 * @param {object} o.meeting public/meeting.js  @param {object} o.pick public/pick.js (enterZone)
 * @param {(p) => void} o.walkTo  @param {() => object|null} o.scene the map's scene once it's up
 * @param {() => Promise} o.load deck/index.js loadRooms  @param {{id, name}} o.floor  @param {() => boolean} o.blocked the map editor
 * @param {(text: string) => void} o.toast
 */
export function initRooms(o) {
  const st = document.createElement('style'); st.textContent = CSS; document.head.append(st);
  const phone = matchMedia(PHONE);
  let want = 'map'; try { if (localStorage.getItem(KEY) === 'rooms') want = 'rooms'; } catch {}
  let view = null, loading = null, timer = 0, sig = '', items = [], on = false;

  // the switch in the top bar (next to 设置 and the floor picker)
  const seg = document.createElement('div'); seg.id = 'viewSeg'; seg.setAttribute('role', 'group'); tr(seg, null, null, { 'aria-label': 'rooms.switch' });
  const btn = (v, key) => { const b = document.createElement('button'); b.type = 'button'; b.dataset.v = v; tr(b, key); b.onclick = () => pickView(v); seg.append(b); return b; };
  const bMap = btn('map', 'rooms.map'), bRooms = btn('rooms', 'rooms.rooms');
  bMap.className = 'on'; bMap.setAttribute('aria-pressed', 'true'); bRooms.setAttribute('aria-pressed', 'false');
  document.getElementById('topleft')?.append(seg);

  /** The switch: remembered, and shown at once. */
  function pickView(v) {
    want = v; try { localStorage.setItem(KEY, v); } catch {}
    sync();
  }
  /** Show the map for now (进去, 走过去): the switch says 地图, what was picked stays for next time. */
  function showMap() { want = 'map'; sync(); }

  function sync() {
    const should = want === 'rooms' && phone.matches && !!o.scene() && !o.meeting.full() && !o.blocked();
    if (bRooms.classList.contains('on') !== (want === 'rooms')) {
      bMap.classList.toggle('on', want !== 'rooms'); bRooms.classList.toggle('on', want === 'rooms');
      bMap.setAttribute('aria-pressed', String(want !== 'rooms')); bRooms.setAttribute('aria-pressed', String(want === 'rooms'));
    }
    if (should && !view) { open(); return; }
    if (should === on) return;
    on = should;
    document.body.classList.toggle('rooms-on', on);
    view?.setVisible(on);
    clearInterval(timer); timer = 0;
    if (on) { sig = ''; tick(); timer = setInterval(tick, TICK_MS); }
  }
  function open() {
    if (loading) return;
    loading = o.load().then(({ RoomsView }) => {
      view = new RoomsView(o.scene(), { onAction: action, onPerson: person });
      sync();
    }).catch((e) => { console.error('rooms view', e); o.toast(t('rooms.loadFailed')); want = 'map'; loading = null; sync(); });
  }

  // ---- what each room holds now
  const nameOf = (p) => String(p.name || t('rooms.otter'));
  function entry(p, mine, meetingRoom) {
    const s = o.statusOf(p), talking = !!o.speaking(p) && (p.kind !== 'agent' || !!p.clip);
    const look = o.lookOf(p), sc = o.scene();
    return { id: p.id, name: nameOf(p), mine, agent: p.kind === 'agent', talking, muted: !!p.muted && !talking,
      cam: mine ? !!(meetingRoom && o.meeting.info()?.cam?.on) : !!p.camTrack,
      status: s && s.s !== 'available' ? o.STATES[s.s]?.icon ?? null : null,
      sheet: sc?.sheets ? sc.sheets.key(look) : null };
  }
  function model() {
    const me = o.me(), all = [me, ...o.peers().values()].filter((p) => p && Number.isFinite(p.x));
    const zones = o.MAP.zones ?? [], inZone = new Map(zones.map((z) => [z.id, []])), deck = [];
    for (const p of all) {
      const z = o.zoneAt(p.x, p.y);
      if (z && inZone.has(z.id)) inZone.get(z.id).push(p); else deck.push(p);
    }
    const order = (a, b) => (b === me) - (a === me) || (a.kind === 'agent') - (b.kind === 'agent') || nameOf(a).localeCompare(nameOf(b), 'zh');
    const full = [], empty = [];
    for (const z of zones) {
      const ps = inZone.get(z.id).sort(order), here = !!me && ps.includes(me), hut = HUTS.has(z.id);
      const kind = hut ? t(KIND.game) : z.meeting ? t(KIND.meeting) : '';
      let action = null;
      if (here) action = z.meeting && o.meeting.room() === z.id && o.meeting.canShow() ? { text: t('rooms.act.back'), primary: true } : null;
      else if (z.meeting && ps.length) action = { text: t('rooms.act.joinMeeting'), primary: true };
      else action = { text: hut ? t('rooms.act.joinGame') : t('rooms.act.enter'), primary: false }; // (the words of the map's room card, pick.js)
      const count = t('rooms.count', { n: ps.length });
      const sub = [here ? t('rooms.here') : null, count, kind || null].filter(Boolean).join(' · ');
      const it = { type: 'room', id: z.id, title: z.name, icon: hut ? 'gamepad' : z.meeting ? 'people' : 'door', sub, here, action,
        people: ps.map((p) => entry(p, p === me, z.meeting)) };
      (ps.length ? full : empty).push(it);
    }
    const out = [...full];
    if (deck.length) {
      const ps = deck.sort(order), here = !!me && ps.includes(me), sea = ps.filter((p) => p.boat).length;
      out.push({ type: 'room', id: ':deck', title: t('rooms.deck'), icon: 'otter', here, action: null,
        sub: [here ? t('rooms.here') : null, t('rooms.count', { n: ps.length }), sea ? t('rooms.atSea', { n: sea }) : null].filter(Boolean).join(' · '),
        people: ps.map((p) => entry(p, p === me, false)) });
    }
    if (empty.length) out.push({ type: 'sep', id: ':empty', text: t('rooms.empty') }, ...empty);
    return { items: out, n: all.length, rooms: zones.length };
  }
  function tick() {
    if (!view || !on) return;
    // the panel: under the top pills, over the bottom bar, inside the safe areas
    const ui = view.ui, bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--barh')) || 64;
    const top = pillsBottom();
    const x = 8 + ui.safe.left, y = Math.max(top + 8, ui.safe.top + 8), w = ui.view.w - x - 8 - ui.safe.right, h = ui.view.h - y - bar - 8;
    view.setRect(x, y, w, Math.max(120, h));
    const m = model(), s = JSON.stringify(m.items);
    view.setHead(t('rooms.head'), t('rooms.headSub', { floor: o.floor?.name ?? '', rooms: m.rooms, n: m.n }).replace(/^ · /, ''));
    if (s === sig) return;
    // an item that didn't change stays the same object, so its row isn't drawn again (deck/ui/scroll.js rebinds a row
    // only when its item changed): someone starting to talk redraws their room's card, not the list
    const was = new Map(items.map((it) => [it.id, it])), same = (a, b) => !!a && JSON.stringify(a) === JSON.stringify(b);
    sig = s; items = m.items.map((it) => (same(was.get(it.id), it) ? was.get(it.id) : it)); view.setItems(items);
  }

  /** The bottom of the top bar's pills (not #topleft's: the 在线 list opens inside it), CSS px; also kept in --pillsb. */
  let pillsb = -1;
  function pillsBottom() {
    const pills = [...(document.getElementById('topleft')?.children ?? [])].filter((e) => e.id !== 'onlineList' && e.getClientRects().length);
    const b = Math.round(pills.length ? Math.max(...pills.map((e) => e.getBoundingClientRect().bottom)) : 50);
    if (b !== pillsb) { pillsb = b; document.documentElement.style.setProperty('--pillsb', b + 'px'); }
    return b;
  }

  // ---- taps
  async function action(it) {
    const z = (o.MAP.zones ?? []).find((q) => q.id === it.id);
    if (!z) return;
    if (it.here) { if (z.meeting) o.meeting.show(); return; }
    if (await o.pick.enterZone(z)) showMap();
  }
  async function person(it, id) {
    const p = o.peers().get(id); if (!p) return;
    if (await o.walkTo(p)) showMap(); // (no way there: the mover says so itself)
  }

  phone.addEventListener?.('change', sync);
  setInterval(() => { if (phone.matches) pillsBottom(); if ((want === 'rooms') !== on) sync(); else if (on && (o.meeting.full() || o.blocked())) sync(); }, 500);
  // for tests and agents looking at the page (set once the map is up: deck/scene.js makes window.__deck afresh)
  const api = { on: () => on, items: () => items, pick: pickView, action: (id) => { const it = (on ? items : model().items).find((q) => q.id === id); if (it) action(it); return !!it; } };
  return { /** The map is up (app.js start): the switch shows, and 房间 opens now if it was picked. */ ready() { (window.__deck ??= {}).rooms = api; seg.classList.add('ready'); sync(); }, on: () => on };
}
